
import Edit from "./Edit";
import EditModal from "./EditModal";
import CreateModal from "./CreateModal";
import RemoveModal from "./RemoveModal";

export {
    Edit,
    EditModal,
    CreateModal,
    RemoveModal
};
